import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchData } from 'redux/auth/actions';
import { fetchSegmentTypes, fetchSegments } from 'redux/segments/actions';
import Layout from './Layout';

export class App extends Component {
  componentDidMount() {
    if (!this.isUserLogin()) this.props.fetchAuthData();
    this.props.fetchSegmentTypes();
    this.props.fetchSegments();
  }

  componentDidUpdate(prevProps) {
    if (this.didUserLoggedIn(prevProps)) this.iterioIdentify();
  }

  isUserLogin() {
    return !!this.props.account;
  }

  didUserLoggedIn(prevProps) {
    const prevAccount = !!prevProps.account;
    const account = !!this.props.account;

    return !prevAccount && account;
  }

  iterioIdentify() {
    const { account: { id } } = this.props;
    if (window.iterio && id) window.iterio('identify', id);
  }

  render() {
    const {
      account,
      fetchSuccess,
      fetchPending,
      match,
    } = this.props;

    return (
      <Layout
        account={account}
        fetchSuccess={fetchSuccess}
        fetchPending={fetchPending}
        match={match}
      />
    );
  }
}

const mapStateToProps = state => {
  const { fetchPending, fetchSuccess, fetchFailure, account } = state.auth;
  return { fetchPending, fetchSuccess, fetchFailure, account };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAuthData: () => dispatch(fetchData()),
    fetchSegmentTypes: () => dispatch(fetchSegmentTypes()),
    fetchSegments: () => dispatch(fetchSegments()),
  };
};

App.propTypes = {
  fetchAuthData: PropTypes.func.isRequired,
  fetchSuccess: PropTypes.bool.isRequired,
  fetchPending: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/IterioApp/App.jsx